<script lang="ts">
    import {onMount} from "svelte";

    export let id;
    export let question = '';
    export let scale = 5;
    export let low = 'Totalmente insatisfecho';
    export let high = 'Totalmente satisfecho';
    let values = [];
    export let bold = false;

    onMount(() => {
        for (let i = 0; i < scale; i++) {
            values = [...values, i+1];
        }
    })

</script>
<div class="border-bottom mb-2">
    {#if bold}
        <p><strong>{question}</strong></p>
    {:else}
        <p>{question}</p>
    {/if}
    <div class="box-b my-15">
        <div style="max-width: 170px;">
            <p style="font-size:.9rem; min-width: 170px;">{low}</p>
        </div>
        <div class="box-a flex-100 max-w-500px">
            {#each values as value}
                <label class="box">
                    <input type="radio" class="mr-ii" name="{id}" value="{value}">
                    <span>{value}</span>
                </label>
            {/each}
        </div>
        <div style="max-width: 170px;">
            <p style="font-size:.9rem; min-width: 170px;">{high}</p>
        </div>
    </div>
</div>
<style>
    input[type='radio']:before{
        color: #B6B6B6;
    }
    input[type='radio']:checked:before{
        color: var(--green);
    }
</style>